module.exports = __webpack_public_path__ + "assets/img/close-blue-lighter.98850bfa.svg";